import { Button } from '@sky-distribution/react-commons-ui';
import styled from 'styled-components';

export const StyledTryAgainButton = styled(Button)`
  width: 100%;
  min-height: 56px;
`;
